
export default {
  name: 'DefaultRoute',

  layout({ store }) {
    const { globalType } = store.state.pageData;
    return globalType === 'ABOUTUS' ? 'two_column_with_left_sidebar' : 'default';
  },

  data() {
    return {
      pageTypes: {
        PLP: 'ProductListing',
        PARENT_CATEGORY: 'CategoryPage',
        PDP: 'ProductPage',
        PROMOPAGE: 'ProductListing',
        SALES_LANDING: 'SalesLandingPage',
        ABOUTUS: 'AboutUs',
        CMS: 'HelpCenterPage',
        CONTACTUS: 'HelpCenterPage',
        TRACK_ORDER_FORM: 'TrackMyOrderPage',
      },
    };
  },

  computed: {
    // Get the current page type from the Vuex store
    pageType() {
      return this.$store.state.pageData.globalType;
    },

    // Get the page component name based on the page type
    pageName() {
      return this.pageTypes[this.pageType] || '';
    },

    // Determine the required layout based on the page type
    requiredLayout() {
      return this.pageType === 'ABOUTUS' ? 'two_column_with_left_sidebar' : 'default';
    },
  },

  watch: {
    // Watch for changes in the pageType and update the layout accordingly
    pageType: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue && process.client) {
          this.updateLayout();
        }
      },
      immediate: true,
    },

    // Watch for route changes to update the layout
    $route: {
      handler() {
        if (process.client) {
          this.$nextTick(() => {
            this.updateLayout();
          });
        }
      },
    },
  },

  mounted() {
    this.updateLayout();
  },

  methods: {
    updateLayout() {
      const newLayout = this.requiredLayout;
      if (this.$nuxt && this.$nuxt.setLayout) {
        this.$nuxt.setLayout(newLayout);
      }
      this.$forceUpdate();
    },
  },

  // This hook is called when the route is entered, allowing us to update the layout
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(() => {
        vm.updateLayout();
      });
    });
  },

  // This hook is called when the route is updated, allowing us to update the layout
  beforeRouteUpdate(to, from, next) {
    next();
    this.$nextTick(() => {
      this.updateLayout();
    });
  },
};
